import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  jwVideo: {},
  playingVideoId: '',
  playingVideoTime: 0,
  isWatchingFullscreen: false,
  currentQuizId: '',
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}
